import { startTransition } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Select, Text } from '@nvision/ui';

import { Card } from '@/components/card';

import { ROUTES } from '../../../config';
import { useContractsControls } from '../../../hooks';

import styles from './contracts-controls.module.css';

export const ContractsControls: React.FC = () => {
  const navigate = useNavigate();

  const { analysisCount, changeSort, isAnalysisDisabled, openContractAnalysis, selectedSortOption, sortOptions } =
    useContractsControls();

  const openCreate = () => {
    startTransition(() => {
      navigate(ROUTES.contractNew());
    });
  };

  return (
    <Card>
      <Card.Header>
        <Text size="sm" weight="semibold">
          Contract Results
        </Text>
      </Card.Header>
      <Card.Main>
        <div className={styles.controls}>
          <div className={styles.leftSection}>
            <Select
              options={sortOptions}
              value={selectedSortOption}
              placeholder="Select"
              onSelectionChange={changeSort}
              className={styles.sortSelect}
              size="sm"
            />
          </div>

          <div className={styles.rightSection}>
            <Button
              size="sm"
              iconLeft="chart-line"
              onClick={openContractAnalysis}
              isDisabled={isAnalysisDisabled}
              ghost
              outline
            >
              Contract Analysis ({analysisCount})
            </Button>
            <Button size="sm" iconLeft="plus-circle" primary onClick={openCreate}>
              Create
            </Button>
          </div>
        </div>
      </Card.Main>
    </Card>
  );
};
